import React from 'react'
import ReactApexChart from "react-apexcharts";

export default function BarChartPatho() {

    var series = [{
        name: 'Report',
        data: [44, 55, 41, 67, 22, 43, 21, 33, 45, 31, 87, 65]
    }]

    var options = {
        direction: 'left',
        chart: {
            type: 'bar',
            toolbar: {
                show: false
            },
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
        },
        plotOptions: {
            bar: {
                columnWidth: '50%', // Make bars narrower to fit better in RTL
                distributed: true,
                endingShape: 'rounded',
                borderRadius: 3,
            }
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        xaxis: {
            title: {
                text: 'Month Wise Report',
                style: {
                    fontSize: '12px',
                },
                offsetX: -20, // Adjust the x-axis title position for RTL
            },

            categories: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'June',
                'July',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            labels: {
                rotate: -45,
                // offsetX: -10, // Adjust label offset to avoid overlap with bars
            },
        },
        yaxis: {
            opposite: localStorage.getItem('lang_key') == 'ar' ? true : false,
            labels: {
                offsetX: localStorage.getItem('lang_key') == 'ar' ? -20 : 0,
            }
        },
        // fill: {
        //     opacity: 0.6
        // },
    }
    return <ReactApexChart options={options} series={series} type="bar" height={350} />;
}



